import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';

const CONTEXT = 'earningsHistory';

export const fetchEarningsHistory = (filters) => {
  const { url } = DepsService.rest.widgets.earningsHistory;
  const queryParams = { ...filters };
  const urlParams = {};

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const downloadEarningsHistoryReport = ({ extension, ...filters }) => {
  const { url } = DepsService.rest.widgets.earningsHistory;
  const queryParams = { ...filters, locale: '*' };
  const urlParams = {};
  const headers = appHelpers.setHeader(extension);

  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams, headers);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/earnings-history.api.js